import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/providers/StoreProvider';
import { GameState } from '../types';
import { Flex } from 'antd';
import { MyTimer } from '@/shared/ui/MyTimer';
import ImgPause from '@/shared/pictures/pause.png';
import ImgPlay from '@/shared/pictures/play.png';
import ImgSoundOn from '@/shared/pictures/sound_on.png';
import ImgSoundOff from '@/shared/pictures/sound_off.png';

export const Buttons = observer(() => {
    const { userStore,gameStore, soundStore,effectsStore } = useStore();
    const {gameState} = gameStore;
    const isEnergy = userStore.gameInfo.user.energy > 0;
    const energyRemainingTime = userStore.gameInfo.user.energyRemainingTime;
    const multiScore = effectsStore.getScoreMultiplier();
    return (

      <>
      {
        gameState != GameState.pause
        ?
        <Flex gap={9}>
          <button type='button' style={{width:53*gameStore.scale, height:53*gameStore.scale}} className={`game-page_button game-page_button-pause`} onClick={()=>soundStore.toggleSound(gameStore.gameState)}>
                {soundStore.enabled
                ? <img src={ImgSoundOn} alt="sound" />
                : <img src={ImgSoundOff} alt="sound" />
                }
          </button>
          <button type='button' style={{width:224*gameStore.scale, height:53*gameStore.scale}} className={`game-page_button game-page_button-start ${!isEnergy&&'disable'}`} onClick={()=>gameStore.onKickClick()}>
                {isEnergy
                  ? `Удар! ${multiScore > 1? 'X'+multiScore:''}`
                  : <Flex align='center' justify='center' gap={5}><p>Через: </p><MyTimer date={energyRemainingTime} /></Flex>
                }
          </button>

          <button type='button' style={{width:53*gameStore.scale, height:53*gameStore.scale}} className={`game-page_button game-page_button-pause ${gameState != GameState.active&&'disable'}`} onClick={()=>gameStore.setGamePause()}>
                <img src={ImgPause} alt="pause" />
          </button>
        </Flex>
        :
        <button type='button' style={{width:350*gameStore.scale, height:53*gameStore.scale}} className={`game-page_button game-page_button-continue`} onClick={()=>gameStore.setGameContinue()}>
            Продолжить игру
           <img src={ImgPlay} alt="play" />
        </button>
      }

      </>
    );

});
